var content = require("!!../../../../../node_modules/css-loader/index.js??ref--0-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--0-2!../../../../../node_modules/sass-loader/lib/loader.js!./ToggleFavoriteButton.scss");
var loader = require("c:\\agents\\agent.01\\_work\\27\\s\\node_modules\\@microsoft\\load-themed-styles\\lib\\index.js");

if(typeof content === "string") content = [[module.id, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-favorites/lib/components/ToggleFavoriteButton.scss
// module id = 2331
// module chunks = 46 105